






















import { computed, defineComponent, ref } from "@vue/composition-api";
import { Appointment } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { FormFields } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";
import UserBadgeWithAvatar from "@/components/UserBadgeWithAvatar";
import { appointmentTypeNames } from "@/views/PageAppointments/config";

export default defineComponent({
  name: "AppointmentCancelConfirm",
  components: { UserBadgeWithAvatar, BaseForm, BaseButton, BaseConfirm },
  props: {
    show: { type: Boolean, required: true },
    appointment: { type: Object as () => Appointment | null, default: null },
  },
  setup(props, { emit }) {
    const { authUserStrict } = useAuthUser();
    const processing = ref(false);
    const values = ref({ message: "" });
    const fields = computed<FormFields>(() => [
      {
        type: "textarea",
        name: "message",
        autocomplete: "off",
        fieldClass: "appointment-cancel__message",
        maxlength: "100",
      },
    ]);

    const isProvider = computed(() => {
      if (!props.appointment) return false;
      return authUserStrict.value.id === props.appointment.providerId;
    });

    const opponent = computed(() => {
      if (!props.appointment) return;
      return authUserStrict.value.id === props.appointment.consumerId
        ? props.appointment.provider
        : props.appointment.consumer;
    });

    const cancelText = computed(() => {
      return isProvider.value
        ? $t("Money will be refunded to the user")
        : $t("No refunds if canceled less than 3 hours before the start");
    });

    const onSubmit = async () => {
      processing.value = true;
      emit("confirm", values.value.message, () => {
        values.value.message = "";
        processing.value = false;
      });
    };

    return {
      appointmentTypeNames,
      fields,
      cancelText,
      values,
      opponent,
      processing,
      isProvider,
      onSubmit,
    };
  },
});
